import Image from "next/image"
import { v4 as uuidv4 } from "uuid"

import tailwindConfig from "../../../../tailwind.config"
import { ArrowRightIcon } from "@/icons"
import Link from "next/link"
import { getTranslate } from "@/tolgee/server"

type HeroProps = {
  image: string
  heading: string
  paragraph: string
  buttons: { label: string; path: string }[]
}

export const Hero = async ({ image, heading, paragraph, buttons }: HeroProps) => {
  const t = await getTranslate()
  return (
    <section className="w-full flex container mt-5 flex-col lg:flex-row text-primary">
      <div className="w-full relative">
        <div className="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] w-full h-full max-w-full max-h-full z-10 xl:max-w-[500px] xl:max-h-[250px]">
          <div className="absolute w-full h-full bg-white left-0 top-0 -z-10 xl:opacity-75 opacity-25"></div>
          <div className="font-bold text-4xl w-full h-full flex justify-center items-center text-ui-fg-subtle p-4">
            <div>
              <span className="text-8xl">FBE</span>
              <br />
              <br />
              Fulfillment by easycreate
            </div>
          </div>
        </div>
        <div className="w-full h-[600px] relative">
          <Image
            src={decodeURIComponent(image)}
            objectFit="cover"
            fill
            alt={t("hero.image_alt")}
            className="w-full order-2 lg:order-1"
          />
        </div>
      </div>

      <div className="w-full lg:order-2">
        <div className="border rounded-sm w-full px-6 flex items-end h-[calc(100%-144px)]">
          <div>
            <h1 className="font-bold mb-12 mt-12 uppercase display-md max-w-[652px]">
              {heading}
            </h1>
            <p className="text-lg mb-8">{paragraph}</p>
            <p className="text-lg mb-8">Leveraging AI-driven marketing and an integrated global supply network, EasyCreate empowers enterprises to achieve borderless growth with turnkey international trade solutions.</p>
          </div>
        </div>
        {buttons.length && (
          <div className="h-[72px] lg:h-[144px] flex font-bold uppercase">
            {buttons.map(({ label, path }) => (
              <Link
                key={uuidv4()}
                href={path}
                className="group flex border rounded-sm h-full w-1/2 bg-content hover:bg-action hover:text-tertiary transition-all duration-300 p-6 justify-between items-end"
              >
                <span>
                  <span className="group-hover:inline-flex hidden">#</span>
                  {label}
                </span>

                <ArrowRightIcon
                  color={tailwindConfig.theme.extend.backgroundColor.primary}
                />
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}
